"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AETHEvents = exports.AETH = void 0;
var AETH_json_1 = __importDefault(require("./abi/AETH.json"));
var BaseContract_1 = require("./BaseContract");
var EventBase_1 = require("../EventBase");
var AETH = /** @class */ (function (_super) {
    __extends(AETH, _super);
    function AETH(web3, network) {
        var _this = _super.call(this, web3, network) || this;
        _this.abi = AETH_json_1.default;
        _this.events = new AETHEvents(_this.getContract());
        return _this;
    }
    AETH.prototype.getName = function () {
        return 'AETH';
    };
    AETH.prototype.allowance = function (owner, spender, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['allowance'](owner, spender).call()];
            });
        });
    };
    AETH.prototype.approve = function (spender, amount, options) {
        return this.getContract().methods['approve'](spender, amount).send(options);
    };
    AETH.prototype.balanceOf = function (account, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['balanceOf'](account).call()];
            });
        });
    };
    AETH.prototype.decimals = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['decimals']().call()];
            });
        });
    };
    AETH.prototype.decreaseAllowance = function (spender, subtractedValue, options) {
        return this.getContract().methods['decreaseAllowance'](spender, subtractedValue).send(options);
    };
    AETH.prototype.increaseAllowance = function (spender, addedValue, options) {
        return this.getContract().methods['increaseAllowance'](spender, addedValue).send(options);
    };
    AETH.prototype.owner = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['owner']().call()];
            });
        });
    };
    AETH.prototype.renounceOwnership = function (options) {
        return this.getContract().methods['renounceOwnership']().send(options);
    };
    AETH.prototype.totalSupply = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['totalSupply']().call()];
            });
        });
    };
    AETH.prototype.transfer = function (recipient, amount, options) {
        return this.getContract().methods['transfer'](recipient, amount).send(options);
    };
    AETH.prototype.transferFrom = function (sender, recipient, amount, options) {
        return this.getContract().methods['transferFrom'](sender, recipient, amount).send(options);
    };
    AETH.prototype.transferOwnership = function (newOwner, options) {
        return this.getContract().methods['transferOwnership'](newOwner).send(options);
    };
    AETH.prototype.mint = function (account, amount, options) {
        return this.getContract().methods['mint'](account, amount).send(options);
    };
    AETH.prototype.updateRatio = function (newRatio, options) {
        return this.getContract().methods['updateRatio'](newRatio).send(options);
    };
    AETH.prototype.ratio = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['ratio']().call()];
            });
        });
    };
    AETH.prototype.updateGlobalPoolContract = function (globalPoolContract, options) {
        return this.getContract().methods['updateGlobalPoolContract'](globalPoolContract).send(options);
    };
    AETH.prototype.burn = function (amount, options) {
        return this.getContract().methods['burn'](amount).send(options);
    };
    AETH.prototype.symbol = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['symbol']().call()];
            });
        });
    };
    AETH.prototype.name = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContract().methods['name']().call()];
            });
        });
    };
    AETH.prototype.setNewNameAndSymbol = function (options) {
        return this.getContract().methods['setNewNameAndSymbol']().send(options);
    };
    AETH.prototype.changeOperator = function (operator, options) {
        return this.getContract().methods['changeOperator'](operator).send(options);
    };
    return AETH;
}(BaseContract_1.BaseContract));
exports.AETH = AETH;
var AETHEvents = /** @class */ (function (_super) {
    __extends(AETHEvents, _super);
    function AETHEvents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AETHEvents.prototype.getPastApproval = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // @ts-ignore
                return [2 /*return*/, this.contract.getPastEvents('Approval', options)];
            });
        });
    };
    AETHEvents.prototype.getPastOwnershipTransferred = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // @ts-ignore
                return [2 /*return*/, this.contract.getPastEvents('OwnershipTransferred', options)];
            });
        });
    };
    AETHEvents.prototype.getPastRatioUpdate = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // @ts-ignore
                return [2 /*return*/, this.contract.getPastEvents('RatioUpdate', options)];
            });
        });
    };
    AETHEvents.prototype.getPastTransfer = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // @ts-ignore
                return [2 /*return*/, this.contract.getPastEvents('Transfer', options)];
            });
        });
    };
    AETHEvents.prototype.Approval = function (options) {
        return this.contract.events.Approval(options);
    };
    AETHEvents.prototype.OwnershipTransferred = function (options) {
        return this.contract.events.OwnershipTransferred(options);
    };
    AETHEvents.prototype.RatioUpdate = function (options) {
        return this.contract.events.RatioUpdate(options);
    };
    AETHEvents.prototype.Transfer = function (options) {
        return this.contract.events.Transfer(options);
    };
    return AETHEvents;
}(EventBase_1.EventBase));
exports.AETHEvents = AETHEvents;
//# sourceMappingURL=AETH.js.map